import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../services/data.service';

@Pipe({
  name: 'roleLabel',
  pure: false,
})
export class RoleLabelPipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private dataService: DataService
  ) {}

  transform(roleKey: string): string {
    if (!roleKey) return '';

    const building = this.dataService.getBuilding();
    const lang = this.translate.currentLang || this.translate.defaultLang || 'es';
    
    // 1. Try white-label custom label
    const customLabel = building?.config?.whiteLabel
      ?.projects?.dashboard?.roleLabels?.[roleKey]?.[lang];
    
    if (customLabel) {
      return customLabel;
    }
    
    // 2. Fallback to i18n translation (check both 'roles' and 'rols' keys)
    const translationKey = `roles.${roleKey}`;
    const translated = this.translate.instant(translationKey);
    
    // If translation exists and is not the same as the key (meaning it was found)
    if (translated !== translationKey) {
      return translated;
    }
    
    // 3. Try alternative 'rols' key (legacy support)
    const altKey = `rols.${roleKey}`;
    const altTranslated = this.translate.instant(altKey);
    
    if (altTranslated !== altKey) {
      return altTranslated;
    }
    
    // 4. Final fallback: return the role key itself
    return roleKey;
  }
}
